import React from "react";
import { Row } from "react-grid-system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";

import useGetResources from "../../hooks/useGetResources";
import LoadingSpinner from "../components/LoadingSpinner";

function Medialive({ eventId, environment, theme }) {
    const { resources, error, isLoaded, refetchResources, isRefetching } = useGetResources(
        eventId,
        environment,
        "get_event_medialive_channels"
    );

    if (!isLoaded) {
        return <LoadingSpinner />;
    }

    function Base64Image({ base64String }) {
        const binaryData = atob(base64String);
        const byteArray = new Uint8Array(binaryData.length);

        for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "image/png" });
        const imageUrl = URL.createObjectURL(blob);

        return <img src={imageUrl} alt="Base64 Image" />;
    }

    return (
        <div className="mt-2">
            <div className="card">
                <Row className="card-header">
                    <div className="mx-4">
                        <h4>Medialive channel</h4>
                    </div>
                    <div>
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={refetchResources}
                            title="Refresh"
                            disabled={isRefetching}
                        >
                            <FontAwesomeIcon icon={faRotate} />
                        </button>
                    </div>
                    <div>
                        {isRefetching && (
                            <div
                                className="spinner-border spinner-border-sm text-primary m-2"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        )}
                    </div>
                </Row>
                {resources.length > 0 ? getMedialiveTable() : <p className="my-2">No Channel found!</p>}
            </div>
        </div>
    );

    function getMedialiveTable() {
        return (
            <div className="card-body p-0">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">State</th>
                            <th scope="col">Channel ID</th>
                            <th scope="col">Thumbnail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resources.map((resource, index) => (
                            <tr key={index}>
                                <td className="align-middle">{resource.name}</td>
                                <td className={`align-middle ${getMedialiveColor(resource.state)}`}>
                                    {resource.state}
                                </td>
                                <td className="align-middle">{resource.channelId}</td>
                                <td className="align-middle">
                                    <Base64Image base64String={resource.thumbnailBase64} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Medialive;

function getMedialiveColor(state) {
    switch (state) {
        case "RUNNING":
            return "text-success";
        case "STARTING":
            return "text-warning";
        case "TERMINATED":
            return "text-light";
        default:
            return "";
    }
}
